// extracted by mini-css-extract-plugin
export default {"buttons":"sort-filters-options_buttons__+x+dX"};